module.exports = __webpack_public_path__ + "img/Finishing.378a1f79.jpg";